import { render, staticRenderFns } from "./productAllInfo.vue?vue&type=template&id=28be93fa&scoped=true"
import script from "./productAllInfo.vue?vue&type=script&lang=js"
export * from "./productAllInfo.vue?vue&type=script&lang=js"
import style0 from "./productAllInfo.vue?vue&type=style&index=0&id=28be93fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28be93fa",
  null
  
)

export default component.exports